import dayjs from 'dayjs';
import { ConcentrationFields, MainFormFields, ResultFields } from './constant';
import { EditReportForm, ReportDetailsById } from './types';
import { stripCustPrefix } from '../../../utils/CommonFunctions';

export function assignValues(selectedReportDetails:ReportDetailsById, setValue: SetValue) {
  [
    { name: MainFormFields.TaiReportNumber, value: selectedReportDetails?.TaiReportNo },
    { name: MainFormFields.SampleNumber, value: selectedReportDetails?.SampleNo },
    {
      name: MainFormFields.ReportDate,
      value: selectedReportDetails?.ReportDate ? dayjs(selectedReportDetails?.ReportDate) : null,
    },
    { name: MainFormFields.SerialNumber, value: selectedReportDetails?.SerialNo },
    {
      name: MainFormFields.DateReceived,
      value: selectedReportDetails?.DateReceived ? dayjs(selectedReportDetails?.DateReceived) : null,
    },
    { name: MainFormFields.Location, value: selectedReportDetails?.Location },
    {
      name: MainFormFields.DateDrawn,
      value: selectedReportDetails?.DateDrawn ? dayjs(selectedReportDetails?.DateDrawn) : null,
    },
    { name: MainFormFields.UnitMake, value: selectedReportDetails?.UnitMake },
    { name: MainFormFields.UnitModel, value: selectedReportDetails?.UnitModel },
    {
      name: MainFormFields.DateTested,
      value: selectedReportDetails?.DateTested ? dayjs(selectedReportDetails?.DateTested) : null,
    },
    { name: MainFormFields.CustomerNumber, value: stripCustPrefix(selectedReportDetails?.CustNo) },
    { name: MainFormFields.Manufacturer, value: selectedReportDetails?.Manufacture },
    { name: MainFormFields.Model, value: selectedReportDetails?.Model },
    { name: MainFormFields.KitNumber, value: selectedReportDetails?.KitNo },
    { name: MainFormFields.UnitNumber, value: selectedReportDetails?.UnitSerialNo },
    { name: MainFormFields.CompanySerialNumber, value: selectedReportDetails?.CompanySerial },
    { name: MainFormFields.Component, value: selectedReportDetails?.Component },

    { name: ConcentrationFields.Silicon, value: selectedReportDetails?.Silicon },
    { name: ConcentrationFields.SiliconSEV, value: selectedReportDetails?.SiliconSev },
    { name: ConcentrationFields.Iron, value: selectedReportDetails?.Iron },
    { name: ConcentrationFields.IronSEV, value: selectedReportDetails?.IronSev },
    { name: ConcentrationFields.Chromium, value: selectedReportDetails?.Chromium },
    { name: ConcentrationFields.ChromiumSEV, value: selectedReportDetails?.ChromiumSev },
    { name: ConcentrationFields.Aluminium, value: selectedReportDetails?.Aluminium },
    { name: ConcentrationFields.AluminiumSEV, value: selectedReportDetails?.AluminiumSev },
    { name: ConcentrationFields.Copper, value: selectedReportDetails?.Copper },
    { name: ConcentrationFields.CopperSEV, value: selectedReportDetails?.CopperSev },
    { name: ConcentrationFields.Lead, value: selectedReportDetails?.Lead },
    { name: ConcentrationFields.LeadSEV, value: selectedReportDetails?.LeadSev },
    { name: ConcentrationFields.Tin, value: selectedReportDetails?.Tin },
    { name: ConcentrationFields.TinSEV, value: selectedReportDetails?.TinSev },
    { name: ConcentrationFields.Nickel, value: selectedReportDetails?.Nickel },
    { name: ConcentrationFields.NickelSEV, value: selectedReportDetails?.NickleSev },
    { name: ConcentrationFields.Molybdenum, value: selectedReportDetails?.Molybdenum },
    { name: ConcentrationFields.MolybdenumSEV, value: selectedReportDetails?.MolybdenumSev },
    { name: ConcentrationFields.Sodium, value: selectedReportDetails?.Sodium },
    { name: ConcentrationFields.SodiumSEV, value: selectedReportDetails?.SodiumSev },
    { name: ConcentrationFields.Magnesium, value: selectedReportDetails?.Magnesium },
    { name: ConcentrationFields.MagnesiumSEV, value: selectedReportDetails?.MagnesiumSev },
    { name: ConcentrationFields.Boron, value: selectedReportDetails?.Boron },
    { name: ConcentrationFields.BoronSEV, value: selectedReportDetails?.BoronSev },
    { name: ConcentrationFields.Barium, value: selectedReportDetails?.Barium },
    { name: ConcentrationFields.BariumSEV, value: selectedReportDetails?.BariumSev },
    { name: ConcentrationFields.Phosphorus, value: selectedReportDetails?.Phosphorus },
    { name: ConcentrationFields.PhosphorusSEV, value: selectedReportDetails?.PhosphorousSev },
    { name: ConcentrationFields.Calcium, value: selectedReportDetails?.Calcium },
    { name: ConcentrationFields.CalciumSEV, value: selectedReportDetails?.CalciumSev },
    { name: ConcentrationFields.Visc, value: selectedReportDetails?.Visc },
    { name: ConcentrationFields.ViscSEV, value: selectedReportDetails?.ViscSev },
    { name: ConcentrationFields.Zinc, value: selectedReportDetails?.Zinc },
    { name: ConcentrationFields.ZincSEV, value: selectedReportDetails?.ZincSev },
    { name: ConcentrationFields.WaterKF, value: selectedReportDetails?.WaterKf },
    { name: ConcentrationFields.WaterKFSEV, value: selectedReportDetails?.WaterKfSev },
    { name: ConcentrationFields.TAN, value: selectedReportDetails?.Tan },
    { name: ConcentrationFields.TANSEV, value: selectedReportDetails?.TanSev },
    { name: ConcentrationFields.Potassium, value: selectedReportDetails?.Potassium },
    { name: ConcentrationFields.PotassiumSEV, value: selectedReportDetails?.PotassiumSev },
    { name: ConcentrationFields.Manganese, value: selectedReportDetails?.Manganese },
    { name: ConcentrationFields.ManganeseSEV, value: selectedReportDetails?.ManganeseSev },
    { name: ConcentrationFields.Titanium, value: selectedReportDetails?.Titanium },
    { name: ConcentrationFields.TitaniumSEV, value: selectedReportDetails?.TitaniumSev },
    { name: ConcentrationFields.Vanadium, value: selectedReportDetails?.Vanadium },
    { name: ConcentrationFields.VanadiumSEV, value: selectedReportDetails?.VanadiumSev },
    { name: ConcentrationFields.Silver, value: selectedReportDetails?.Silver },
    { name: ConcentrationFields.SilverSEV, value: selectedReportDetails?.SilverSev },
    { name: 'severity', value: selectedReportDetails?.Condition },

    { name: ResultFields.OilChanged, value: selectedReportDetails?.OilChanged },
    { name: ResultFields.FluidType, value: selectedReportDetails?.FluidType },
    { name: ResultFields.FluidBrand, value: selectedReportDetails?.FluidBrand },
    { name: ResultFields.FluidGrade, value: selectedReportDetails?.FluidGrade },
    { name: ResultFields.MHMRUnit, value: selectedReportDetails?.MhMrUnit },
    { name: ResultFields.CompAge, value: selectedReportDetails?.CompAge },
    { name: ResultFields.FilterAge, value: selectedReportDetails?.FilterAge },
    { name: ResultFields.MhOil, value: selectedReportDetails?.MhOil },
    { name: ResultFields.OilAdded, value: selectedReportDetails?.OilAdded },
    { name: ResultFields.Condition, value: selectedReportDetails?.Condition },
    { name: ResultFields.Result, value: selectedReportDetails?.Result },
  ].forEach(({ name, value }) => setValue(name, value));
}

export function assignPayload(values:EditReportForm, reportId: string) {
  return {
    ReportId: reportId,
    CustId: values.customerNumber,
    TaiReportNo: values.taiReportNumber,
    SampleNo: values.sampleNumber,
    ReportDate: values.reportDate ? dayjs(values?.reportDate).format('MM-DD-YYYY') : '',
    SerialNo: values.serialNumber,
    DateReceived: values.dateRecieved ? dayjs(values?.dateRecieved).format('MM-DD-YYYY') : '',
    Location: values.location,
    DateDrawn: values.dateDrawn ? dayjs(values?.dateDrawn).format('MM-DD-YYYY') : '',
    UnitMake: values.unitMake,
    UnitModel: values.unitModel,
    DateTested: values.dateTested ? dayjs(values?.dateTested).format('MM-DD-YYYY') : '',
    CustNo: values.customerNumber,
    Manufacture: values.manufacturer,
    Model: values.model,
    KitNo: values.kitNumber,
    UnitNo: values.unitNumber,
    CompanySerial: values.companySerialNumber,
    Component: values.component,
    Silicon: values.silicon,
    SiliconSev: values.siliconSEV || '',
    Iron: values.iron,
    IronSev: values.ironSEV || '',
    Chromium: values.chromium,
    ChromiumSev: values.chromiumSEV || '',
    Aluminium: values.aluminium,
    AluminiumSev: values.aluminiumSEV || '',
    Copper: values.copper,
    CopperSev: values.copperSEV || '',
    Lead: values.lead,
    LeadSev: values.leadSEV || '',
    Tin: values.tin,
    TinSev: values.tinSEV || '',
    Nickel: values.nickel,
    NickleSev: values.nickelSEV || '',
    Molybdenum: values.molybdenum,
    MolybdenumSev: values.molybdenumSEV || '',
    Magnesium: values.magnesium,
    MagnesiumSev: values.magnesiumSEV || '',
    Sodium: values.sodium,
    SodiumSev: values.sodiumSEV || '',
    Boron: values.boron,
    BoronSev: values.boronSEV || '',
    Barium: values.barium,
    BariumSev: values.bariumSEV || '',
    Phosphorus: values.phosphorus,
    PhosphorousSev: values.phosphorusSEV || '',
    Calcium: values.calcium,
    CalciumSev: values.calciumSEV || '',
    Visc: values.visc,
    ViscSev: values.viscSEV || '',
    Zinc: values.zinc,
    ZincSev: values.zincSEV || '',
    WaterKf: values.waterKF,
    WaterKfSev: values.waterKFSEV || '',
    Tan: values.tan,
    TanSev: values.tanSEV || '',
    Potassium: values.potassium,
    PotassiumSev: values.potassiumSEV || '',
    Titanium: values.titanium,
    TitaniumSev: values.titaniumSEV || '',
    Vanadium: values.vanadium,
    VanadiumSev: values.vanadiumSEV || '',
    Manganese: values.manganese,
    ManganeseSev: values.manganeseSEV || '',
    FluidType: values.fluidType,
    FluidBrand: values.fluidBrand,
    FluidGrade: values.fluidGrade,
    MhMrUnit: values.mhMrUnit,
    CompAge: values.compAge,
    FilterAge: values.filterAge,
    MhOil: values.mhOil,
    OilAdded: values.oilAdded,
    Condition: values.severity,
    Result: values.result,
    OilChanged: values.oilChanged,
    Silver: values.silver,
    SilverSev: values.silverSEV || '',
  };
}
